<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        <!-- <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
        <b-nav-item class="px-3" to="/settings">Settings</b-nav-item> -->
      </b-navbar-nav>
      <b-navbar-nav class="d-md-down-none ml-auto">
        <b-link class="navbar-brand" to="#" style="margin-right: 100px;">
          <img class="navbar-brand-full" src="img/sm-logo-new.png" width="275px" alt="SourceMatrix">
          <img class="navbar-brand-minimized" src="img/sm-logo-new.png" width="275px" alt="SourceMatrix">
        </b-link>
      </b-navbar-nav>
      <b-navbar-nav style="margin-left: 15px;" class="d-md-down-none ml-auto">
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdown/>
        </b-nav-item>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
    </AppHeader>
    <div class="app-body">
      <AppSidebar :show.sync="showSidebar">
        <!-- <SidebarHeader/> -->
        <!-- <SidebarForm/> -->
        <SidebarNav :navItems="navItems"></SidebarNav>
        <!-- <SidebarFooter/> -->
        <!-- <SidebarMinimizer @click.native="resizeHeaderToContainer" /> -->
      </AppSidebar>
      <main class="main">
        <!-- <Breadcrumb :list="list"/> -->
        <div class="container-fluid vld-parent" ref="loadingContainer">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <!--footer-->
    <!-- <TheFooter>
      <div>
        <a>Ultra ERP</a>
        <span class="ml-1">&copy; 2019 Palm Beach Software.</span>
      </div> -->
      <!-- <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>
      </div> -->
    <!-- </TheFooter> -->
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNavDivider, SidebarNav, Aside as AppAside, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdown from './DefaultHeaderDropdown'
import { mapGetters } from 'vuex';
export default {
  name: 'DefaultContainer',
  components: {
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    SidebarNavDivider
  },
  data () {
    return {
      navItems: nav.items,
      showSidebar: false,
    }
  },
  computed: {
    ...mapGetters('global', ['containerLoader']),
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    },
  },
  methods: {
    resizeHeaderToContainer() {
      setTimeout(() => {
        const $fixedHeaderNav = document.getElementById('fixed-header-nav');
        const $containerFluid = document.getElementsByClassName('container-fluid')[0];

        if($fixedHeaderNav && $containerFluid) {
          $fixedHeaderNav.style.width = $containerFluid.clientWidth + 'px';
        }
      }, 250);
    },
    onClickDD() {
      console.log(">>>>")
    }
    /*clearFilter(){
      let elements = document.getElementsByClassName('clear-data')
      for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', ()=>{
          console.log('we are here');
        }, false);
      }
    }*/
  },
  watch: {
    containerLoader(newVal){
      if (newVal) {
        this.loader = this.$loading.show({
          container: this.$refs.loadingContainer,
          canCancel: true,
          /*onCancel: this.yourMethodName,*/
          color: '#000000',
          loader: 'dots', //spinner or dots or bars
          width: 64,
          height: 64,
          backgroundColor: '#ffffff',
          opacity: 0.5,
          zIndex:999,
        });
        setTimeout(() => {
          this.loader.hide();
        },10000)
      } else if(this.loader) {
        this.loader.hide();
      }
    }
  }
}
</script>
